import React from 'react';
import Goods from '../db/db.js';
import CategoryItems from './CategoryItems.jsx';
import buildGoodsArray from '../db/db.js';

const Category = (props) =>{
	const category=buildGoodsArray(props.category);
	return(
		<section className='category'>
			{
				category.map((i,n) =>{
					return <CategoryItems match={props.match} key={n} n={n} product={i}/>
				})
			}
		</section>
	)
};

export default Category;